import type { FinalCtaContent } from "../types";

export const finalCta: FinalCtaContent = {
  draftingLabels: ["PLATE 01", "UCLOUD AI / INFRASTRUCTURE", "REV. 01 / SYSTEM READY"],
  titleLine1: "Sovereign AI, ",
  titleLine2: "made in Denmark.",
  subtitle:
    "Log in with your university ID, pick a model, and take your " +
    "research to the next level. Your data stays in Denmark, and you " +
    "stay in control.",
  ctaPrimary: "Try it",
  ctaSecondary: "Contact us",
};
